var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((5),function(num,index){return _c('img',{key:index,style:({ height: _vm.size == 'mid' ? '1.5em' : '1em'}),attrs:{"src":index>=_vm.languageDetails.level?require('@/assets/star-off.svg'):require('@/assets/star-on.svg'),"alt":""},on:{"click":function($event){return _vm.$emit('level-selected',index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }